module.exports = __webpack_public_path__ + "img/19.fe4d10e2.jpg";